import { render, staticRenderFns } from "./AgencyComparePriorityTree.vue?vue&type=template&id=06a055fa&scoped=true&"
import script from "./AgencyComparePriorityTree.vue?vue&type=script&lang=js&"
export * from "./AgencyComparePriorityTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a055fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout})
